import store from '@/pages/LayerDeviceControl/store'

export const showSpaceSelected = (space): boolean => {
  if (!store.selectedFeature) return false
  return space.pid === store.getSelectedSpace().pid
}
